/**
 * "PC 버전 보기"(specs/037 FR-004) — 선택을 탭 세션에 기억(uiMode=pc)한 뒤 PC 첫 화면(허용된 첫 메뉴 — `/workspace` 진입 분기, specs/065)으로 보낸다.
 * 같은 탭 세션 동안은 워크스페이스에 다시 들어와도 PC 화면이 열리고, 새로 방문하면 다시 기기 판별을 따른다.
 */
import { useCallback } from 'react';
import { useNavigate } from 'react-router';

import { ROUTES } from '@/config/routes';
import { useUiModeStore } from '@/stores/uiMode';

export function useSwitchToPc() {
  const navigate = useNavigate();
  const setUiMode = useUiModeStore((s) => s.setUiMode);
  return useCallback(
    (to: string = ROUTES.workspace.root) => {
      setUiMode('pc');
      navigate(to);
    },
    [navigate, setUiMode],
  );
}
